import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { gql } from 'apollo-boost'
import { Formik } from 'formik'
import * as yup from 'yup'

import Text from '../Text'
import Loading from '../Loading'
import Form from '../Form'

const GET_MANUFACTURER = gql`
  query manufacturer($id: ID!) {
    manufacturer(id: $id) {
      id
      name
    }
  }
`

const UPDATE_MANUFACTURER = gql`
  mutation updateManufacturer(
  $id: ID!
  $name: String!
  ) {
    updateManufacturer(
      id: $id
      name: $name
    ) {
      id
      name
    }
  }
`

const validationSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Name is required')
})

const onSubmit = (values, {setSubmitting}, updateManufacturer) => {
  updateManufacturer({variables: values})
  setSubmitting(false)
}

const Update = ({id, onCompleted, onError}) =>
  <Query
    query={GET_MANUFACTURER}
    variables={{id}}
    fetchPolicy='cache-and-network'>
    {({loading, error, data}) => {
      if (loading) return <Loading />
      if (error) return <Text error>{error.message}</Text>
      if (!data.manufacturer) return <Text>Nothing was found!</Text>

      return (
        <Mutation
          mutation={UPDATE_MANUFACTURER}
          onCompleted={onCompleted}
          onError={onError}>
          {(updateManufacturer) =>
            <Formik
              initialValues={{
                id: data.manufacturer.id || '',
                name: data.manufacturer.name || ''
              }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => onSubmit(values, actions, updateManufacturer)}>
              {({values}) =>
                <Form>
                  <Text h2 secondary mb={3}>{values.name}</Text>
                  <Text>There is currently nothing to update.</Text>
                </Form>
              }
            </Formik>
          }
        </Mutation>
      )
    }}
  </Query>

export default Update


// WEBPACK FOOTER //
// ./src/components/Manufacturers/Update.js